import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { AnalyticsClientManager } from "@ucreact/analytics-client-manager-web";

const isAnalyticsEnabled = process.env.REACT_APP_ENVIRONMENT === 'production';

AnalyticsClientManager.init({
  server: {
    log: !isAnalyticsEnabled,
    disabled: !isAnalyticsEnabled,
    userType: "provider",
    clientType: "product-web",
    appVersion: "0.0.1",
    loginStatus: false,
    deviceOs: "desktop_web"
  },
  clevertap: {
    disabled: true,
    clientType: "product-web",
    appVersion: "0.0.1",
    loginStatus: false
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
